import SearchableDropdown from '../../../../components/SearchableDropdown';
import { TRANSACTION_TYPES } from './utils';

const LedgerFilters = ({
    selection, setSelection, wings, flats, memberOptions,
    wingsDropdownLoading, flatsDropdownLoading, membersLoading,
    filters, setFilters, onApply, onReset,
}) => {
    return (
        <div className="tw-bg-white tw-rounded-xl tw-border tw-border-gray-100 tw-shadow-sm tw-p-4 tw-mb-4">
            <div className="tw-flex tw-flex-wrap tw-items-end tw-gap-3">
                <div className="tw-w-40">
                    <label className="tw-text-xs tw-font-medium tw-text-gray-500 tw-mb-1 tw-block">Wing</label>
                    <SearchableDropdown
                        value={selection.wing_id}
                        onChange={(val) => setSelection({ wing_id: val, flat_id: 'all', member_id: 'all' })}
                        options={wings}
                        valueKey="wing_id"
                        labelKey="title"
                        placeholder="Select Wing"
                        loading={wingsDropdownLoading}
                        small
                    />
                </div>
                <div className="tw-w-40">
                    <label className="tw-text-xs tw-font-medium tw-text-gray-500 tw-mb-1 tw-block">Flat</label>
                    <SearchableDropdown
                        value={selection.flat_id}
                        onChange={(val) => setSelection(prev => ({ ...prev, flat_id: val, member_id: 'all' }))}
                        options={flats}
                        valueKey="flat_id"
                        labelKey="flat_number"
                        placeholder="Select Flat"
                        loading={flatsDropdownLoading}
                        disabled={selection.wing_id === 'all'}
                        small
                    />
                </div>
                <div className="tw-w-44">
                    <label className="tw-text-xs tw-font-medium tw-text-gray-500 tw-mb-1 tw-block">Member</label>
                    <SearchableDropdown
                        value={selection.member_id}
                        onChange={(val) => setSelection(prev => ({ ...prev, member_id: val }))}
                        options={memberOptions}
                        valueKey="id"
                        labelKey="label"
                        placeholder="Select Member"
                        loading={membersLoading}
                        disabled={selection.flat_id === 'all'}
                        small
                    />
                </div>

                <div className="tw-w-px tw-h-7 tw-bg-gray-200 tw-mx-1" />

                <div className="tw-w-36">
                    <label className="tw-text-xs tw-font-medium tw-text-gray-500 tw-mb-1 tw-block">Start Date</label>
                    <input
                        type="date"
                        value={filters.startDate}
                        onChange={(e) => setFilters(prev => ({ ...prev, startDate: e.target.value }))}
                        className="tw-w-full tw-px-2.5 tw-py-1.5 tw-border tw-border-gray-200 tw-rounded tw-text-xs tw-text-gray-700 focus:tw-outline-none focus:tw-border-blue-500 focus:tw-ring-1 focus:tw-ring-blue-500"
                    />
                </div>
                <div className="tw-w-36">
                    <label className="tw-text-xs tw-font-medium tw-text-gray-500 tw-mb-1 tw-block">End Date</label>
                    <input
                        type="date"
                        value={filters.endDate}
                        onChange={(e) => setFilters(prev => ({ ...prev, endDate: e.target.value }))}
                        className="tw-w-full tw-px-2.5 tw-py-1.5 tw-border tw-border-gray-200 tw-rounded tw-text-xs tw-text-gray-700 focus:tw-outline-none focus:tw-border-blue-500 focus:tw-ring-1 focus:tw-ring-blue-500"
                    />
                </div>
                <div className="tw-w-40">
                    <label className="tw-text-xs tw-font-medium tw-text-gray-500 tw-mb-1 tw-block">Transaction Type</label>
                    <select
                        value={filters.transactionType}
                        onChange={(e) => setFilters(prev => ({ ...prev, transactionType: e.target.value }))}
                        className="tw-w-full tw-px-2.5 tw-py-1.5 tw-border tw-border-gray-200 tw-rounded tw-text-xs tw-text-gray-700 focus:tw-outline-none focus:tw-border-blue-500 focus:tw-ring-1 focus:tw-ring-blue-500 tw-bg-white"
                    >
                        {TRANSACTION_TYPES.map(t => (
                            <option key={t.value} value={t.value}>{t.label}</option>
                        ))}
                    </select>
                </div>

                <button
                    onClick={onApply}
                    className="tw-px-3.5 tw-py-1.5 tw-bg-blue-600 tw-text-white tw-rounded tw-text-xs tw-font-medium hover:tw-bg-blue-700 tw-transition-colors"
                >
                    Apply
                </button>
                <button
                    onClick={onReset}
                    className="tw-px-3.5 tw-py-1.5 tw-text-gray-500 tw-rounded tw-text-xs tw-font-medium tw-border tw-border-gray-200 hover:tw-bg-gray-50 tw-transition-colors"
                >
                    Reset
                </button>
            </div>
        </div>
    );
};

export default LedgerFilters;
